import React from "react";
import { AbsoluteFill } from "remotion";

export interface SafeZoneOverlayProps {
  visible?: boolean;
  opacity?: number;
}

/**
 * TikTok & Instagram Reels 9:16 Safe Zone Visualizer (1080x1920)
 * Bantuan visual di Remotion Studio untuk memantau batas obstruction UI platform.
 */
export const SafeZoneOverlay: React.FC<SafeZoneOverlayProps> = ({
  visible = true,
  opacity = 0.65,
}) => {
  if (!visible) return null;

  return (
    <AbsoluteFill
      style={{
        pointerEvents: "none",
        zIndex: 9999,
        opacity,
        fontFamily: "monospace",
      }}
    >
      {/* ─── TOP OBSTRUCTION (0 - 200px) ─────────────────────────── */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "200px",
          backgroundColor: "rgba(239, 68, 68, 0.25)",
          borderBottom: "2px dashed #ef4444",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fca5a5",
          fontSize: "18px",
          fontWeight: 700,
        }}
      >
        ⚠️ TOP OBSTRUCTION (0 - 200px) • Status Bar / Tabs / Search
      </div>

      {/* ─── BOTTOM OBSTRUCTION (1540 - 1920px) ──────────────────── */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "380px", // 1540px to 1920px
          backgroundColor: "rgba(239, 68, 68, 0.25)",
          borderTop: "2px dashed #ef4444",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#fca5a5",
          fontSize: "18px",
          fontWeight: 700,
          gap: "8px",
        }}
      >
        <div>⛔ BOTTOM OBSTRUCTION (1540 - 1920px)</div>
        <div style={{ fontSize: "14px", fontWeight: 500, color: "#fecaca" }}>
          Caption (1-4 baris), Username, Sound Title, TikTok Shop & Bottom Nav
        </div>
      </div>

      {/* ─── RIGHT ACTION RAIL (X: 940 - 1080px, Y: 700 - 1500px) ── */}
      <div
        style={{
          position: "absolute",
          top: "650px",
          right: 0,
          width: "140px",
          height: "850px",
          backgroundColor: "rgba(245, 158, 11, 0.25)",
          borderLeft: "2px dashed #f59e0b",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#fde68a",
          fontSize: "14px",
          fontWeight: 700,
          textAlign: "center",
          padding: "8px",
        }}
      >
        <div>⚠️ RIGHT RAIL</div>
        <div style={{ fontSize: "11px", marginTop: "4px" }}>
          Like • Comment • Save • Share
        </div>
      </div>

      {/* ─── LEFT MARGIN (0 - 80px) ──────────────────────────────── */}
      <div
        style={{
          position: "absolute",
          top: "200px",
          left: 0,
          width: "80px",
          bottom: "380px",
          backgroundColor: "rgba(59, 130, 246, 0.15)",
          borderRight: "1px dashed #3b82f6",
        }}
      />

      {/* ─── SUBTITLE GOLDEN BAND (Y: 1450 - 1520px) ─────────────── */}
      <div
        style={{
          position: "absolute",
          top: "1450px",
          left: "80px",
          width: "860px",
          height: "70px",
          border: "2px solid #10b981",
          backgroundColor: "rgba(16, 185, 129, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#a7f3d0",
          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        ✨ SUBTITLE GOLDEN BAND (Y: 1450 - 1520px)
      </div>

      {/* ─── THE MASTER SAFE BOX BORDER ──────────────────────────── */}
      <div
        style={{
          position: "absolute",
          top: "220px",
          left: "80px",
          width: "860px",
          height: "1230px", // 220px to 1450px
          border: "2px solid #22c55e",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "8px",
            left: "8px",
            color: "#86efac",
            fontSize: "12px",
            fontWeight: 700,
          }}
        >
          ✅ MASTER SAFE ZONE (X: 80 - 940px, Y: 220 - 1450px)
        </div>
      </div>
    </AbsoluteFill>
  );
};
